export default __webpack_public_path__ + "static/media/grail.cb435718.png";